module.exports = __webpack_public_path__ + "static/origin-story-0381c9099a049102450ba057bd5a4e53.jpg";